<template>
  <div class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-dark">
      <div
        class="navbar-header"
        v-bind:style="{
          'background-color': cia.color_fondo_logo
        }"
      >
        <!-- This is for the sidebar toggle which is visible on mobile only -->
        <a
          class="nav-toggler waves-effect waves-light d-block d-md-none"
          href="javascript:void(0)"
        >
          <i id="option_abrir_sidever" class="ti-menu ti-close"></i>
        </a>
        <a class="navbar-brand" v-on:click.prevent="Dashboard">
          <span class="logo-text">
            <!-- dark Logo text -->
            <img
              src="static/libs_template/assets/images/logo-text.png"
              alt="homepage"
              class="dark-logo"
            />
            <!-- Light Logo text
                        <img src="static/libs_template/assets/images/logo-light-text.png" class="light-logo" alt="homepage" />
                         -->
            <img
              v-bind:src="empresa.logo"
              style="max-width: 200px; max-height: 60px"
              class="light-logo"
              alt="homepage"
            />
          </span>
        </a>
        <a
          class="topbartoggler d-block d-md-none waves-effect waves-light"
          href="javascript:void(0)"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i class="ti-more"></i>
        </a>
      </div>
      <div
        class="navbar-collapse collapse"
        v-bind:style="{
          color: cia.color_texto_header,
          'background-color': cia.color_fondo_header
        }"
        id="navbarSupportedContent"
      >
        <ul
          v-bind:style="{
            color: cia.color_texto_header
          }"
          class="navbar-nav float-left mr-auto"
        >
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item d-none d-md-block"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link sidebartoggler waves-effect waves-light"
              href="javascript:void(0)"
              data-sidebartype="mini-sidebar"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="sl-icon-menu font-20"
              />
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item dropdown"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link dropdown-toggle waves-effect waves-dark"
              href=""
              v-on:click="Actualizar_Notificaciones"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="ti-bell font-20"
                v-if="total_notificaciones == 0"
              />
              <span
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="badge-notification mt-5"
                v-bind:data-badge="total_notificaciones"
                v-else
              >
                <i
                  v-bind:style="{
                    color: cia.color_texto_header
                  }"
                  class="ti-bell font-20"
                />
              </span>
            </a>
            <div
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="dropdown-menu mailbox animated bounceInDown"
            >
              <span
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="with-arrow"
              >
                <span
                  v-bind:style="{
                    color: cia.color_texto_header
                  }"
                  class="bg-primary"
                />
              </span>
              <ul class="list-style-none">
                <li>
                  <div class="drop-title bg-danger text-white">
                    <h4 class="m-b-0 m-t-5" v-if="total_notificaciones > 1">
                      {{ total_notificaciones }} {{ $t("page.header_logo.notificaciones_nuevas") }}
                    </h4>
                    <h4
                      class="m-b-0 m-t-5"
                      v-else-if="total_notificaciones == 1"
                    >
                      {{ total_notificaciones }} {{ $t("page.header_logo.notificacion_nueva") }}
                    </h4>
                    <h4 class="m-b-0 m-t-5" v-else>{{ $t("page.header_logo.no_tienes_notificaciones") }}</h4>
                  </div>
                </li>
                <li>
                  <div class="message-center notifications">
                    <!-- Message -->
                    <a
                      href=""
                      v-on:click.prevent="Ver_Notificacion(notificacion)"
                      v-for="notificacion,index of notificaciones" :key="index+'not'"
                      class="message-item"
                    >
                      <span class="btn btn-danger btn-circle">
                        <i
                          v-if="notificacion.icono.length > 5"
                          v-bind:class="notificacion.icono"
                        ></i>
                        <i v-else class="fa fa-link"></i>
                      </span>
                      <div class="mail-contnet">
                        <h5 class="message-title">
                          {{ notificacion.titulo }}
                        </h5>
                        <span class="mail-desc">
                          {{ notificacion.contenido }}
                        </span>
                        <span class="time">
                          {{ notificacion.fecha }}
                        </span>
                      </div>
                    </a>
                  </div>
                </li>
                <li>
                  <a
                    class="nav-link text-center text-dark"
                    href=""
                    v-on:click.prevent="ejecutar_ruta('Notificaciones')"
                  >
                    <strong> {{ $t("page.header_logo.ver_notificaciones") }} </strong>
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item dropdown"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link dropdown-toggle waves-effect waves-dark"
              href=""
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="badge-notification mt-5"
                v-bind:data-badge="total_sesiones"
              >
                <i
                  v-bind:style="{
                    color: cia.color_texto_header
                  }"
                  class="fas fa-users font-20"
                />
              </span>
            </a>
            <div class="dropdown-menu mailbox animated bounceInDown">
              <span class="with-arrow">
                <span class="bg-primary"></span>
              </span>
              <ul
                class="list-style-none"
                @click="
                  ev => {
                    ev.stopPropagation();
                  }
                "
              >
                <li>
                  <div class="drop-title bg-danger text-white">
                    <span class="font-light" v-if="total_sesiones > 0"
                      >{{ $t("page.header_logo.usuarios_activos") }}</span
                    >
                  </div>
                </li>
                <li>
                  <div class="message-center notifications">
                    <!-- Message -->
                    <a
                      href="javascript:void(0)"
                      v-for="sesion of sesiones"
                      class="message-item"
                      :key="'sesion' + sesion.clave"
                      @click="
                        ev => {
                          ev.stopPropagation();
                        }
                      "
                    >
                      <div class="container">
                        <div class="row justify-content-between w-100">
                          <div class="col-10">
                            <span class="btn btn-sm btn-danger btn-circle">
                              <i class="fa fa-link"></i>
                            </span>
                            <div
                              class="mail-contnet"
                              style="display:inline-flex;"
                            >
                              <span class="mail-desc">
                                {{ sesion.nombre }}
                              </span>
                            </div>
                          </div>
                          <div
                            class="col-2"
                            v-if="
                              usuario.usuario_sistema == 'Administrador' ||
                                usuario.usuario_sistema == 'HISE'
                            "
                          >
                            <button
                              class="btn btn-success btn-md"
                              v-on:click="liberar_sesion(sesion.clave)"
                            >
                              <i class="fas fa-cogs"></i>
                            </button>
                          </div>
                          <div
                            class="col-2"
                            v-else-if="
                              usuario.usuario_sistema == 'Rep. Empresa' &&
                                usuario.subordinados.includes(sesion.clave)
                            "
                          >
                            <button
                              class="btn btn-success btn-md"
                              v-on:click="liberar_sesion(sesion.clave)"
                            >
                              <i class="fas fa-cogs"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul
          v-bind:style="{
            color: cia.color_texto_header
          }"
          class="navbar-nav float-right"
        >
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box d-none"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Teams')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-video pt-3 font-20"
              />
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box"
            v-show="
              usuario_permisos.nomseccion1.indexOf('Dashboard') >= 0 &&
                usuario_permisos.nomseccion2.indexOf('Ayuda') >= 0 &&
                usuario_permisos.nomseccion3.indexOf('Envio ticket') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header,
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Ayuda')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header,
                  'font-size':'1.5em'
                }"
                class="fas fa-ticket-alt"
              ></i>
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box"
            v-show="
              usuario_permisos.nomseccion1.indexOf('APIs Externas') >= 0 &&
                usuario_permisos.nomseccion2.indexOf('Consultar APIs') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Apis')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-paper-plane font-16"
              ></i>
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box"
            v-show="
                usuario_permisos.nomseccion2.indexOf('Creación perfiles') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('creacion_Perfiles')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-user-plus font-16"
              ></i>
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item search-box"
            v-show="
              usuario_permisos.nomseccion1.indexOf('Panel de Cursos') >= 0 &&
                usuario_permisos.nomseccion2.indexOf('Ver Panel de Cursos') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Panel_Cursos')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-tv font-16"
              />
            </a>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item dropdown"
            v-show="
              usuario_permisos.nomseccion1.indexOf('Configuración') >= 0 &&
                usuario_permisos.nomseccion2.indexOf('Ver Configuración') >= 0
            "
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link waves-effect waves-dark"
              href=""
              v-on:click.prevent="ejecutar_ruta('Configuracion')"
            >
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-cog font-18"
              />
            </a>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown2"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="flag-icon font-18" :class="$i18n.locale == 'es'?'flag-icon-mx':$i18n.locale == 'pt'?'flag-icon-br':'flag-icon-us'"></i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right animated bounceInDown"
              aria-labelledby="navbarDropdown2"
            >
              <a
                class="dropdown-item"
                href="#"
                @click="
                  () => {
                    $i18n.locale = 'es';
                  }
                "
              >
                <i class="flag-icon flag-icon-mx"></i> {{ $t("page.header_logo.espanol") }}</a
              >
              <a
                class="dropdown-item"
                href="#"
                @click="
                  () => {
                    $i18n.locale = 'en';
                  }
                "
              >
                <i class="flag-icon flag-icon-us"></i> {{ $t("page.header_logo.ingles") }}</a
              >
              <a
                class="dropdown-item"
                href="#"
                @click="
                  () => {
                    $i18n.locale = 'pt';
                  }
                "
              >
                <i class="flag-icon flag-icon-br"></i> {{ $t("page.header_logo.portugues") }}</a
              >
            </div>
          </li>
          <li
            v-bind:style="{
              color: cia.color_texto_header
            }"
            class="nav-item dropdown d-none d-lg-block"
          >
            <a
              v-bind:style="{
                color: cia.color_texto_header
              }"
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown2"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ menu.usuario.usuario_sistema }}
              <i
                v-bind:style="{
                  color: cia.color_texto_header
                }"
                class="fas fa-caret-down"
              ></i>
            </a>
            <div
              class="dropdown-menu dropdown-menu-right animated bounceInDown"
              aria-labelledby="navbarDropdown2"
            >
              <a
                class="dropdown-item"
                href=""
                v-on:click.prevent="Cambiar_Perfil_Usuario(perfil)"
                v-for="perfil,index of menu.usuario.perfiles_sistema" :key="index+'perfil'"
              >
                {{ perfil }}
              </a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a
              class="
                nav-link
                dropdown-toggle
                text-muted
                waves-effect waves-dark
                pro-pic
              "
              href=""
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                v-bind:src="menu.usuario.foto_empleado"
                alt="user"
                class="rounded-circle"
                width="31"
              />
            </a>
            <div
              class="dropdown-menu dropdown-menu-right user-dd animated flipInY"
            >
              <span class="with-arrow">
                <span class="bg-danger"></span>
              </span>
              <div
                class="
                  d-flex
                  no-block
                  align-items-center
                  p-15
                  bg-danger
                  text-white
                  m-b-10
                  p-3
                "
              >
                <div class="m-l-10 ml-2">
                  <h4 class="m-b-0">{{ menu.usuario.nombre_empleado }}</h4>
                  <p class="m-b-0">{{ menu.usuario.correo_empleado }}</p>
                  <span id="cambioContrasena" @click="cambiarContrasena()"
                    >{{ $t("page.header_logo.cambio_contraseña") }}</span
                  >
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item text-center"
                href=""
                v-on:click.prevent="Salir"
              >
                <i class="fa fa-power-off m-r-5 m-l-5"></i> {{ $t("page.header_logo.cerrar") }}</a
              >
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <button
      class="btn btn-sm btn-danger d-none"
      id="Cerrar_Sesion_LMS"
      v-on:click="Salir"
    >
      {{ $t("page.header_logo.salir") }}
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { firestore, database } from "@/firebase.js";
export default {
  data() {
    return {
      sesiones: [],
      langs: []
    };
  },
  methods: {
    cambiarContrasena() {
      $("#modalChangePass").modal();
    },
    ejecutar_ruta(route_name) {
      this.$router.push({ name: route_name });
    },
    Dashboard() {
      this.$router.push({ name: "Dashboard" });
    },
    Salir() {
      this.menu.salir = true;
      this.$http
        .delete(
          "../pri/usuarios/sesiones/eliminar/" +
            this.menu.usuario.cve_empleado +
            "/web"
        )
        .then(respuesta => {
          return respuesta.json();
        })
        .then(respuestaJson => {
          this.Actualizar_Token(this.menu.tokenGenerico);
          this.$router.push({ name: "Login" });
          location.reload(true);
        })
        .catch(error => {
          this.Actualizar_Token(this.menu.tokenGenerico);
          this.$router.push({ name: "Login" });
          location.reload(true);
        });
    },
    liberar_sesion(clave) {
      let that = this;
      firestore
        .collection("empresas")
        .doc(that.cia.firebase_firestore)
        .collection("status")
        .doc(clave)
        .update({ state: "offline" })
        .then(() => {
          database
            .ref("empresas/" + that.cia.firebase_firestore + "/status/" + clave)
            .update({ state: "offline" })
            .then(() => {
              toastr.success("Sesión liberada con exito!");
            })
            .catch(() => {
              toastr.error(
                "Hubo un problema para liberar la sesión, por favor contacta al proveedor."
              );
            });
        })
        .catch(() => {
          toastr.error(
            "Hubo un problema para liberar la sesión, por favor contacta al proveedor."
          );
        });
    },
    ...mapActions([
      "Actualizar_Token",
      "Actualizar_Empresa",
      "Actualizar_Notificaciones",
      "Ver_Notificacion",
      "Actualizar_Notificacion",
      "Cambiar_Perfil_Usuario"
    ])
  },
  computed: {
    usuario() {
      return this.$store.getters.getUsuario;
    },
    menu() {
      return this.$store.getters.getMenu;
    },
    cia() {
      return this.$store.getters.getCia;
    },
    empresa() {
      return this.$store.getters.getEmpresa;
    },
    total_notificaciones() {
      return this.$store.getters.getTotalNotificaciones_No_Leidas;
    },
    notificaciones() {
      return this.$store.getters.getNotificaciones;
    },
    notificacion() {
      return this.$store.getters.getNotificacion;
    },
    usuario_permisos() {
      return this.$store.getters.getUsuario_Permisos;
    },
    total_sesiones: function() {
      return this.sesiones.length;
    }
  },
  watch: {
    "cia.firebase_firestore": function() {
      var that = this;
      that.$bind(
        "sesiones",
        firestore
          .collection("empresas")
          .doc(that.cia.firebase_firestore)
          .collection("status")
          .where("state", "==", "online")
          .orderBy("last_changed", "desc")
      );
    }
  },
  created() {
    var that = this;
    //this.Actualizar_Empresa();
  },
  mounted() {
    var that = this;
    if (this.cia.firebase_firestore != "") {
      that.$bind(
        "sesiones",
        firestore
          .collection("empresas")
          .doc(that.cia.firebase_firestore)
          .collection("status")
          .where("state", "==", "online")
          .orderBy("last_changed", "desc")
      );
    }
  }
};
</script>

<style>
#cambioContrasena {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Menu/HeaderLogo.vue